import layoutAdmin from "@/layouts/layoutAdmin.vue";
import CustomerProfileWorkspace from "@/views/module/customerProfile/CustomerProfileWorkspace.vue";

// Customer Profile & SAM Module
export default [
  {
    path: "/customer-profile",
    component: layoutAdmin,
    meta: {
      UserLoggedIn: true,
      breadcrumb: "Customer Profile & SAM",
    },
    children: [
      {
        path: "",
        name: "customer-profile-sam",
        component: CustomerProfileWorkspace,
        meta: { breadcrumb: ["Customer Profile & SAM"] },
      },
    ],
  },
];
